import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ICourse {
  search?: string;
  method?: 'both' | 'premium' | 'free' | string;
  type?: 'courses' | 'teachers' | string;
  sort?: 'popular' | 'new' | 'all' | string;
  categoryIds?: number[];
}

export const initialState: ICourse = {
  search: 'all',
  method: 'both',
  type: 'courses',
  sort: 'all',
  categoryIds: []
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setType: (state, action: PayloadAction<string>) => {
      state.type = action.payload;
    },
    setMethod: (state, action: PayloadAction<string>) => {
      state.method = action.payload;
    },
    setSort: (state, action: PayloadAction<string>) => {
      state.sort = action.payload;
    },
    setCategoryIds: (state, action: PayloadAction<number[] | undefined>) => {
      state.categoryIds = action.payload;
    }
  }
});

export const { setSearch, setType, setMethod, setSort, setCategoryIds } = courseSlice.actions;
export const courseReducer = courseSlice.reducer;
